export enum AssetClassEnum {
  WORKSHEET = 'WORKSHEET',
  INSTRUCTION = 'INSTRUCTION',
  ATTACHMENT = 'ATTACHMENT'
}

export enum AssetTypeEnum {
  SPECIALAWARDING = 'SPECIAL_AWARDING',
  PDF_SLIDES = 'PDF_SLIDES',
  PDF_DOCUMENTS = 'PDF_DOCUMENTS',
  PDF = 'PDF',
  AUDIO_MUSIC = 'AUDIO_MUSIC',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  URL = 'URL',
  URL_YOUTUBE = 'URL_YOUTUBE',
  IMAGE = 'IMAGE',
  RECOGNITION = 'RECOGNITION'
}

export  enum EventTypeEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  SEMESTER = 'SEMESTER',
  SUMMER = 'SUMMER'
}

export enum GroupTypeEnum {
  N_A = 'N_A',
  SECTION = 'SECTION',
  ADHOC = 'ADHOC',
  TEAM = 'TEAM',
  SESSION = 'SESSION',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE',
  GROUP_MESSAGE = 'GROUP_MESSAGE'
}

export enum MessageTypeEnum {
  NOTIFICATION = 'NOTIFICATION',
  PERSISTENT_NOTIFICATION = 'PERSISTENT_NOTIFICATION',
  MESSAGE = 'MESSAGE',
  SYSTEM_MESSAGE = 'SYSTEM_MESSAGE'
}

export enum GeneralStatusEnum {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  SUBMITTED = 'SUBMITTED',
  GRADED = 'GRADED'
}

export enum SchoolYearEnum {
  ACADEMICYEAR = 'ACADEMIC_YEAR',
  FIRSTQUARTER = 'QTR_1',
  SECONDQUARTER = 'QTR_2',
  THIRDQUARTER = 'QTR_3',
  FOURTHQUARTER = 'QTR_4',
  FIRSTTRIMESTER = 'TRI_1',
  SECONDTRIMESTER = 'TRI_2',
  THIRDTRIMESTER = 'TRI_3',
  FIRSTSEMESTER = 'SEM_1',
  SECONDSEMESTER = 'SEM_2',
  SUMMERTERM = 'SUM'
}

export enum EnumSessionType {
  LESSONPLAN = 'LESSONPLAN',
  LESSON = 'LESSON',
  PROGRAM_YEAR = 'PROGRAM_YEAR',
  PROGRAM_SEMESTER = 'PROGRAM_SEMESTER',
  PROGRAM_QUARTER = 'PROGRAM_QUARTER',
  PROGRAM_MONTH = 'PROGRAM_MONTH',
  PROGRAM_WEEK = 'PROGRAM_WEEK',
  PROGRAM_DAY = 'PROGRAM_DAY',
  PROGRAM_MORNING = 'PROGRAM_MORNING',
  PROGRAM_AFTERNOON = 'PROGRAM_AFTERNOON'
}

export enum ContextTypeEnum {
  ITEM = 'ITEM',
  SESSION = 'SESSION',
  SUBJECT_TIME_PERIOD = 'SUBJECT_TIME_PERIOD',
  USER_CONTENT = 'USER_CONTENT'
}

export enum ItemTypeEnum {
  CONTENT = 'CONTENT',
  RECOGNITION = 'RECOGNITION',
  QUIZ = 'QUIZ',
  ASSESSMENT = 'ASSESSMENT',
  SPOTLIGHT = 'SPOTLIGHT',
  ENERGIZER = 'ENERGIZER',
  ASSIGNMENT = 'ASSIGNMENT',
  LESSON = 'LESSON',
  LESSONPLAN = 'LESSONPLAN',
  SPECIALAWARDING = 'SPECIAL_AWARDING'
}

export enum EnumSessionMode {
  STANDARD = 'STANDARD',
  FULLSCREEN = 'FULLSCREEN',
  RECOGNITION = 'RECOGNITION'
}

export enum EnumSessionAttendance {
  ABSENT = 'ABSENT',
  LATE = 'LATE'
}

export enum EnumSessionSettingValueScreen {
  CAMERA = 'CAMERA',
  SCREEN_SHARE = 'SCREEN_SHARE'
}

export enum SessionSettingValue {
  TRUE= 'true', FALSE= 'false'
}

export enum ContentSetting {
  PREFIX = 'content/',
  INFO = 'content/info',
  EXPANSION_STATUS = 'content/info/expansion_status',
  MATERIAL = 'content/material',
  SPOTLIGHT = 'content/spotlight',
  CURRENT_PAGE = 'content/current_page'
}

export enum DisplaySetting {
  PREFIX = 'display/',
  MODE = 'display/screen_mode'
}

export enum HostSessionSettingName {
  PREFIX = 'teacher/',
  NOTE = 'teacher/notes_enabled',
  CHAT = 'teacher/chat_enabled',
  MIC = 'teacher/mic_enabled',
  VIDEO = 'teacher/video_enabled',
  SCREEN_SHARE = 'teacher/screen_share'
}

export enum AttendeeSessionSettingName {
  PREFIX = 'student/',
  NOTE = 'student/notes_enabled',
  CHAT = 'student/chat_enabled',
  MIC = 'student/mic_enabled',
  VIDEO = 'student/video_enabled'
}

export enum UserSettingEnum {
  NOTE = 'user/notes_enabled',
  CHAT = 'user/chat_enabled',
  AUDIO = 'user/audio_enabled',
  VIDEO = 'user/video_enabled'
}

export enum SessionSettingEnum {
    CONFERENCING = 'session/conferencing_enabled',
    ZOOMLINK = 'session/zoom_link'
}

export enum DisplaySettingValue {
  STANDARD = 'STANDARD',
  FULLSCREEN = 'FULLSCREEN',
  PRESENTATION = 'PRESENTATION',
  EVERYONE = 'EVERYONE',
  RECOGNITION = 'RECOGNITION'
}

export enum UserEvents {
  INACTIVE = 'INACTIVE',
  RAISED = 'RAISED',
  BREAK = 'BREAK'
}

export enum StreamTypeEnum {
  CAMERA = 'CAMERA',
  SCREEN_SHARE = 'SCREEN_SHARE'
}

export enum RoleIdNameEnum {
  ADMINISTRATOR = 1,
  TEACHER = 2,
  STUDENT = 3,
  PARTICIPANT = 4,
  HOST = 5,
  ATTENDEE = 6,
  AUDITOR = 7,
  EDITOR = 8
}

export enum RecognitionEnum {
  BEHAVIOR = 'RECOGNITION_BEHAVIOR',
  ACADEMIC = 'RECOGNITION_ACADEMICS'
}
